import { useHospitalDetailContext } from '../hospital-detail-context'

import HospitalMap from '@/features/hospital/components/hospital-map'
import { HospitalAccessSection } from '@/features/hospital/components/HospitalAccessSection'
import { CountryCodes } from '@/utils/language'

export const HospitalDetailAccess = () => {
  const { hospital, analytics } = useHospitalDetailContext()

  return (
    <div>
      {/* 지도 섹션 */}
      <HospitalMap
        address={hospital.location.address}
        lat={hospital.location.lat}
        lng={hospital.location.lng}
        onClickMap={analytics.trackMapClick}
        onClickCopyAddress={analytics.trackCopyAddress}
      />

      {/* 교통편 정보 (일본만) */}
      {hospital.country === CountryCodes.JP && <HospitalAccessSection hospital={hospital} />}
    </div>
  )
}
